var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"media-dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-sending":_vm.sendingEvent,"vdropzone-file-added":_vm.fileAdded,"vdropzone-success":_vm.fileUploaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }